import { authController } from "@reedexpo/authorization-component-ui";
import App from "./App";
import authConfig from "./common/config/auth.config";
import { getUrlParam } from "./common/utils/urlUtils";
import "./index.less";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import { Provider } from "react-redux";
import store from "./redux/store";
import NetworkHelper from "./common/network/helpers/network/helper/NetworkHelper";
import AuthHelper from "./common/auth/helpers/AuthHelper";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
// import reportWebVitals from './reportWebVitals';
import { setAutoFreeze } from 'immer';
import SentryHelper from "./common/sentry/SentryHelper";
import GlobalErrorHandler from "./common/utils/errorHandlers/GlobalErrorHandler";

setAutoFreeze(false);

const authSettings = authConfig.getConfig(process.env.REACT_APP_ENVIRONMENT);

window.authSettings = authSettings;

// Initialize Sentry (for preprod, prod, and local environments)
SentryHelper.init();

// Initialize global error handling
const globalErrorHandler = GlobalErrorHandler.getInstance();
globalErrorHandler.init();

const renderApplication = () => {
  const root = createRoot(document.getElementById("root")!);
  root.render(
    <Provider store={store}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </Provider>
  );
};

const authSettingsDefined = authSettings && authSettings.usePkce;

NetworkHelper.isConnected().then(isConnected => {
  if (!AuthHelper.isWithoutAuth() && authSettingsDefined) {
    authController.initialize(authSettings);
    if (getUrlParam("code", window.location.href)) {
      authController.handleCallback(window.location.search.substring(1));
    } else if (isConnected) {
      authController
        .login(window.location.href)
        .then(() => {
          renderApplication();
        })
        .catch(renderApplication);
    } else {
      renderApplication();
    }
  } else {
    renderApplication();
  }
});

serviceWorkerRegistration.register({});
// reportWebVitals({});
